<template>
  <!-- The birth ring. Rising on the left horizon, bodies where they were in the
       sky over the birthplace. See utils/birth-ring.js. -->
  <svg class="birth-ring" :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`"
       aria-hidden="true">
    <circle :cx="L.cx" :cy="L.cy" :r="L.r" fill="none" stroke="rgba(201,169,78,0.18)" stroke-width="1" />
    <circle :cx="L.cx" :cy="L.cy" :r="L.inner" fill="none" stroke="rgba(201,169,78,0.18)" stroke-width="0.6" />
    <line v-for="(t, i) in L.ticks" :key="i" :x1="t.x1" :y1="t.y1" :x2="t.x2" :y2="t.y2"
          stroke="rgba(201,169,78,0.18)" stroke-width="1" />
    <line :x1="L.horizon.x1" :y1="L.horizon.y1" :x2="L.horizon.x2" :y2="L.horizon.y2"
          stroke="rgba(201,169,78,0.22)" stroke-width="0.8" stroke-dasharray="2 3" />
    <g v-for="b in L.bodies" :key="b.key" class="ring-body" :class="b.key">
      <circle :cx="b.x" :cy="b.y" :r="L.glyphSize * 0.62" fill="#0a0015"
              stroke="rgba(201,169,78,0.55)" stroke-width="1" />
      <text :x="b.x" :y="b.y + L.glyphSize * 0.36" text-anchor="middle"
            :font-size="L.glyphSize" fill="#ffdfa3">{{ b.glyph }}</text>
    </g>
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { ringBodies, ringLayout } from '@/utils/birth-ring'

const props = defineProps({
  // Either payload shape: an object keyed by body, or a list of { body, longitude }.
  placements: { type: [Object, Array], default: null },
  size: { type: Number, default: 120 },
})

const L = computed(() => ringLayout(ringBodies(props.placements), props.size))
</script>

<style scoped>
.birth-ring { display: block; flex-shrink: 0; }
.birth-ring text { font-family: 'Cormorant Garamond', Georgia, serif; }
</style>
